import { render } from "./CustomerCollection.vue?vue&type=template&id=a0836344&scoped=true"
import script from "./CustomerCollection.vue?vue&type=script&lang=js"
export * from "./CustomerCollection.vue?vue&type=script&lang=js"

import "./CustomerCollection.vue?vue&type=style&index=0&id=a0836344&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0836344"]])

export default __exports__